import { gettext } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import React from 'react';

export const CreateEventTitle = () => {
    return (
        <>
            <Typography as="h1" color="neutral-900" variant="heading-md">
                {gettext('Create an event with AI')}
            </Typography>

            <Typography as="p" color="neutral-1000" variant="body-md">
                <span
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: gettext(
                            'Answer a few questions about your event and our AI creation tool will use internal data to build an event page.',
                        ).toString(),
                    }}
                />
            </Typography>
        </>
    );
};
